module.exports = __webpack_public_path__ + "img/map_zhankai.8d0e8358.svg";